/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import Select from 'components/select';
import ProvisioningStyles from 'pages/provisioning/day2-operation-paas/style';
import { sspSubmitOrder } from 'pages/provisioning/store/day2-operation-paas';

const StorageAccount = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [options, setOptions] = React.useState([]);
    const setStorageAccount = (storageAccount, storageAccountDetail) => {
        setOrder({ ...order, storageAccount, storageAccountDetail });
    };
    const storageAccountApi = useMutation(() => axios.get(`${endPoints.ssp.day2OperationPass.storageAccounts}`));
    const seldValueExistsInOptions = (storageAccountValue) => options.find((option) => storageAccountValue === option?.value);
    const handleOnSelectChange = (selected) => {
        if (seldValueExistsInOptions(selected?.value)) {
            setStorageAccount(selected?.value, selected?.data);
        }
    };
    React.useEffect(() => {
        if (storageAccountApi?.isSuccess) {
            if (storageAccountApi?.data?.data) setOptions(storageAccountApi?.data?.data?.map((app) => ({ label: app.name, value: app.name, data: app })));
        }
    }, [storageAccountApi?.isSuccess]);

    React.useEffect(() => {
        storageAccountApi.mutate();
    }, []);
    React.useEffect(() => {
        if (!order?.storageAccount && order?.isTouched) setIsTouched(true);
    }, [order?.storageAccount, order?.isTouched]);

    return (
        <Box sx={ProvisioningStyles.box}>
            <Select
                key="storageAccount"
                label="Storage Account *"
                value={order?.storageAccount || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                disabled={storageAccountApi.isLoading}
                isLoading={storageAccountApi.isLoading}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(StorageAccount);
